import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

function apiOrigin(): string {
  const api = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
  return api.replace(/\/api\/?$/, '');
}

/** Shared Socket.IO client for `/notifications` (same namespace as mobile). */
export function getNotificationsSocket(): Socket {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Not authenticated');
  }
  const origin = apiOrigin();
  if (!socket?.connected) {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
    socket = io(`${origin}/notifications`, {
      auth: { token },
      extraHeaders: { Authorization: `Bearer ${token}` },
      transports: ['websocket'],
    });
  }
  return socket;
}
